import React from "react";
import "./Home.css";
const Home = () => {
  return (
    <div className="landing-page">
      <div className="overlay">
        <img className="flag" src="logo.png" alt="aruba Flag" />
        <div className="overlay-content">
          <h1>Aruba ED Card</h1>
          <p className="description">
            All visitors traveling to Aruba are required to complete an online
            form to obtain the Aruba ED (Embarkation-Disembarkation) Card prior
            to arrival. This mandatory digital card helps facilitate a faster
            and more efficient immigration and customs process.
          </p>
          <p className="highlight">
          Start your Aruba ED Card. Save time with the simplified application and process. 
          </p>
          <a
            className="cta-button"
            href="https://aruba-edcard.online/"
            rel="nofollow noopener noreferrer"
          >
            Get Started
          </a>
          <p className="disclaimer">
          Legal Disclaimer: This website is operated by an independent third-party service provider and is not affiliated with, endorsed by, or operated on behalf of the Government of Aruba.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Home;
